export default __webpack_public_path__ + "static/latitiude-scam-alert-9-98bc106863bb6f38b076aa9ea7d04163.webp";